export default {
  section_title: 'Valuta',
  label: 'Valuta',
  tooltip:
    "La valuta utilizzata per i prezzi, i pagamenti e i report. Viene impostata per il tuo account partner alla creazione e non può essere modificata qui — contatta l'assistenza se non è corretta.",
  from_your_partner: 'Dal tuo partner',
  set_for_your_account: 'Impostata per il tuo account',
};
